import { STATUS_COLORS } from "../lib/api";

export const StatusBadge = ({ status, testId }) => {
  const color = STATUS_COLORS[status] || "#8B949E";
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-2 px-3 py-1 text-xs font-mono font-medium uppercase tracking-wider rounded-sm border"
      style={{
        color,
        borderColor: color,
        backgroundColor: `${color}12`,
        boxShadow: `0 0 10px ${color}55`,
      }}
    >
      <span className="w-1.5 h-1.5 rounded-full animate-pulse-glow" style={{ backgroundColor: color }} />
      {status}
    </span>
  );
};
